module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_21.1116cf5b.png";